export const Instagram = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4997 25.6673H17.4997C23.333 25.6673 25.6663 23.334 25.6663 17.5007V10.5007C25.6663 4.66732 23.333 2.33398 17.4997 2.33398H10.4997C4.66634 2.33398 2.33301 4.66732 2.33301 10.5007V17.5007C2.33301 23.334 4.66634 25.6673 10.4997 25.6673Z"
        stroke="white"
        strokeWidth="1.3125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0003 18.0827C16.2555 18.0827 18.0837 16.2545 18.0837 13.9993C18.0837 11.7442 16.2555 9.91602 14.0003 9.91602C11.7452 9.91602 9.91699 11.7442 9.91699 13.9993C9.91699 16.2545 11.7452 18.0827 14.0003 18.0827Z"
        stroke="white"
        strokeWidth="1.3125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5751 8.16732H20.5886"
        stroke="white"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
